import { PrimitiveType } from '../../../../api/api';
import { ExpressionModel } from '../../Models/ExpressionModel';
import { ExpressionTypes } from '../../Models/ExpressionTypes';
import { VarExpressionModel } from '../../Models/VarExpressionModel';
import { IVariableScope } from '../../Models/VariableScopes/IVariableScope';
import VarPathSelectTree from '../Parameters/VarPathSelectTree';

type VarExpressionInputProps = {
	matchingPrimitiveTypes: PrimitiveType[];
	expression: ExpressionModel | undefined;
	onExpressionChange?: (expression: ExpressionModel) => void;
	variableScope: IVariableScope;
	canCreateVariable?: boolean;
	requireCollection?: boolean;
};

export default function VarExpressionInput({
	matchingPrimitiveTypes,
	expression,
	onExpressionChange,
	variableScope,
	canCreateVariable,
	requireCollection,
}: VarExpressionInputProps) {
	const handleValueChange = (value: string[]) => {
		const newExpression: VarExpressionModel = {
			Type: ExpressionTypes.Var,
			Value: value,
		};
		onExpressionChange?.(newExpression);
	};

	const currentValue = expression?.Value && Array.isArray(expression.Value) ? expression.Value : undefined;

	return (
		<VarPathSelectTree
			matchingPrimitiveTypes={matchingPrimitiveTypes}
			value={currentValue}
			onValueChange={handleValueChange}
			variableScope={variableScope}
			canCreateVariable={canCreateVariable}
			requireCollection={requireCollection}
		/>
	);
}
